import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {ReportComponentDefinitionDataService} from './impl/service/ngrx/reportComponentDefinitionData.service';
import {ReportComponentDefinitionRepository} from './impl/service/ngrx/reportComponentDefinition.repository';
import {ReportComponentDefinitionDataServiceAdapter} from './impl/service/ngrx/reportComponentDefinitionDataService.adapter';
import {ReportComponentDefinitionConverter} from './api/entity/converter/reportComponentDefinition.converter';

@NgModule({
    providers: [
        ReportComponentDefinitionDataService,
        ReportComponentDefinitionRepository,
        ReportComponentDefinitionDataServiceAdapter,
        ReportComponentDefinitionConverter,
    ],
    imports: []
})
export class ReportingComponentDefinitionModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: ReportComponentDefinitionRepository,
                dataService: ReportComponentDefinitionDataService,
    ) {

        entityDataService.registerServices({
            ReportComponentDefinition: dataService,
        });

        entityServices.registerEntityCollectionServices({
            ReportComponentDefinition: repository,
        });

        //  errorMessages.set('PRODUCT_SAVE_CODE_ALREADY_USED', 'Un produit avec ce code existe déjà');
    }
}
